module.exports = __webpack_public_path__ + "img/3a.ce8e7aaf.svg";